import { Component, Inject } from '@angular/core';
import { RmsModule } from '@rms';
import { RmsPulldownRef } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';
import { CONTACT_ROLES } from '../../../../../../shared/interfaces/crm-lookups';

@Component({
  selector: 'app-contact-form',
  imports: [RmsModule],
  templateUrl: './contact-form.component.html',
  styleUrl: './contact-form.component.scss'
})
export class ContactFormComponent {
  Contact: any = {};
  RoleOptions = CONTACT_ROLES.map(r => ({ value: r.ContactRoleID, label: r.RoleName }));

  constructor(@Inject(RMS_PULLDOWN_DATA) private data: any, public ref: RmsPulldownRef) {
    this.Contact = { ...data };
    if (!Array.isArray(this.Contact.RoleIDs)) {
      const names = String(this.Contact.Roles || '').split(',').map(r => r.trim());
      this.Contact.RoleIDs = CONTACT_ROLES.filter(r => names.includes(r.RoleName)).map(r => r.ContactRoleID);
    } else this.Contact.RoleIDs = [...this.Contact.RoleIDs];
    if (this.Contact.IsActive === undefined) this.Contact.IsActive = true;
  }

  get canSave(): boolean {
    const nameOrEmail = [this.Contact.FirstName, this.Contact.LastName, this.Contact.Email].some(v => String(v || '').trim());
    const needsEmail = this.Contact.IsInvoiceRecipient || this.Contact.IsConfirmationRecipient || this.Contact.IsProNotificationRecipient;
    return nameOrEmail && (!needsEmail || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.Contact.Email || ''));
  }

  save() {
    if (!this.canSave) return;
    this.ref.close({ ...this.Contact, cancelled: false });
  }

  cancel() {
    this.ref.close({ cancelled: true });
  }
}
